import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import RecordOccurrencesForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../../redux/actions/loadingActions';
import { classListActivesByFunc } from '../../../shared/queries/SchoolClass';
import GraphQl from '../../../GraphQL';
import { studentListByFilter } from '../../../shared/queries/Student';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { convertDateToHourStr } from '../../../shared/utils/smartutils';

const RecordOccurrencesFormHandler = (props) => {
  const { t, match, history, dispatch } = props;

  const [dto, setDto] = useState({
    id: 0,
    date: new Date().getTime(),
    hour: convertDateToHourStr(new Date().getTime()),
  });
  const [formOn, setFormOn] = useState(false);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const backClickHandler = () => {
    history.push('/minime/ocorrencia');
  };

  const findById = (id) => {
    console.log('-->===>', id);
    setDto({});
  };

  const handleSubmit = (values) => {
    console.log('-->===>', values);
  };

  const loadAllClasses = () => {
    showLoading();
    const query = classListActivesByFunc();
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        setClasses(res.classListActivesByFunc);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllStudents = () => {
    showLoading();
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };
    const query = studentListByFilter(filter);
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
          label: item.fullName,
          value: item.id,
        }));
        setStudents(res.studentListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    loadAllClasses();
    loadAllStudents();
  }, []);

  return (
    <SmartCard title={t('panels.ocorrencias')}>
      {formOn && (
        <RecordOccurrencesForm
          saveForm={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          classes={classes}
          students={students}
        />
      )}
    </SmartCard>
  );
};

RecordOccurrencesFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(RecordOccurrencesFormHandler)
);
